import * as React from 'react';
import { Button } from 'react-bootstrap';

interface IProps {
    index: number;
    storiesLength: number;
    moveUp: () => void;
    moveDown: () => void;
    disabled?: boolean;
}

const StoreySort = (props: IProps) => {
    return (
        <div className="storey-sort">
            {props.index > 0 && !props.disabled && (
                <Button onClick={props.moveUp}>
                    <i className="material-icons">keyboard_arrow_up</i>
                </Button>
            )}
            {props.index < props.storiesLength - 1 && !props.disabled && (
                <Button onClick={props.moveDown}>
                    <i className="material-icons">keyboard_arrow_down</i>
                </Button>
            )}
            {(props.storiesLength === 1 || props.disabled) && (
                <Button disabled>
                    <i className="material-icons">keyboard_arrow_right</i>
                </Button>
            )}
        </div>
    );
};

export default StoreySort;
